import { render } from "./Dialogs.vue?vue&type=template&id=2bf39d4e&scoped=true"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"

import "./Dialogs.vue?vue&type=style&index=0&id=2bf39d4e&scoped=true&lang=css"
import "./Dialogs.vue?vue&type=style&index=1&id=2bf39d4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bf39d4e"]])

export default __exports__